










































import { defineComponent } from '@vue/composition-api';
import IntegratorDatabaseConnectionsRepository from '@/repositories/integrator/IntegratorDatabaseConnectionsRepository';
import DialogHelper from '@/helpers/DialogHelper';

export default defineComponent({
  name: 'RemoveDatabaseConnectionByAliasDialog',
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    databaseAlias: {
      required: false,
      type: String,
    },
    companyGroupId: {
      required: true,
      type: Number,
    },
  },
  computed: {
    dialogWidth(): string {
      return DialogHelper.getDialogWidth(this.$vuetify.breakpoint, {
        smAndDown: '100%',
        md: '60%',
        default: '40%',
      });
    },
  },
  watch: {
    value(): void {
      this.isOpen = this.value;
    },
  },
  data() {
    const integratorDatabaseConnectionsRepository:
      IntegratorDatabaseConnectionsRepository = new IntegratorDatabaseConnectionsRepository();

    const loading = false;
    const isOpen: boolean = this.value;

    return {
      integratorDatabaseConnectionsRepository,
      loading,
      isOpen,
    };
  },
  methods: {
    async deleteDatabaseConnectionByAlias(): Promise<void> {
      try {
        this.$dialog.startLoading();

        await this.integratorDatabaseConnectionsRepository
          .deleteDatabaseConnecitonConfiguration(this.companyGroupId, this.databaseAlias!);

        this.$notification.success('Conexão com o Banco de Dados removida com Sucesso!');
      } catch (error) {
        this.$notification.error('Houve um problema ao remover a conexão do banco de dados.');
      } finally {
        this.$dialog.stopLoading();
      }
    },
    async handleDelete(): Promise<void> {
      await this.deleteDatabaseConnectionByAlias();

      this.$emit('on-remove');
    },
    close(): void {
      this.$emit('close');
    },
  },
});
